/**
 * @file ChallengeLeaderboardTab.jsx
 * @description Leaderboard tab component for MaterialChallenge
 */

import React from "react";
import { ChallengeLeaderboard } from "../../leaderboard/ChallengeLeaderboard";
import { logIn } from "../../../UserAuth";
import { Icon } from "../../Icon";

export const ChallengeLeaderboardTab = ({
  challengeID,
  challengeData,
  datesToChapters,
  user,
  challengeType,
  goalPercent,
  isChallengeAdmin
}) => {
  const titleText = challengeType === 'cooperative' ? 'progress' : 'leaderboard';

  if (!user) {
    return (
      <div style={{ 
        height: '100%', 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px 16px',
        gap: '16px'
      }}>
        <Icon name="signIn" size="hero" style={{ color: 'var(--md-sys-color-on-surface-variant)' }} />
        <p style={{ 
          margin: '0', 
          fontSize: '16px',
          color: 'var(--md-sys-color-on-surface-variant)',
          textAlign: 'center'
        }}>
          Log in to view {titleText}!
        </p>
        <button 
          onClick={logIn}
          style={{ 
            backgroundColor: 'var(--md-sys-color-primary)',
            color: 'var(--md-sys-color-on-primary)',
            border: 'none',
            borderRadius: '20px',
            padding: '12px 24px',
            fontSize: '14px',
            fontWeight: '500',
            minWidth: '200px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            fontFamily: 'var(--md-sys-typescale-label-large-font)',
            textTransform: 'uppercase',
            letterSpacing: '0.1px'
          }}
        >
          <Icon name="signIn" style={{ fontSize: '18px' }} />
          Sign In
        </button>
      </div>
    );
  }

  return (
    <div style={{ height: '100%', overflow: 'hidden' }}>
      <ChallengeLeaderboard 
        challengeId={challengeID}
        challengeName={challengeData?.challenge_name || 'Challenge'}
        challengePortions={datesToChapters.length}
        isStandalone={false}
        challengeType={challengeType}
        goalPercent={goalPercent}
        datesToChapters={datesToChapters}
        isChallengeAdmin={isChallengeAdmin}
      />
    </div>
  );
};
